export class Globals {
    public static BASE_URL_API_REST: string = 'https://willani.mondo-go.com/';
  }